import { useAsyncData } from '#imports'
import { type MaybeRef, unref } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useFetchOpenFacets(id: MaybeRef<string>) {
  const $httpFetch = useHttpFetch()
  const idValue = unref(id)

  return useAsyncData(
    `facet-plp-open-facets-${idValue}`,
    () =>
      $httpFetch('/facet-plp/v1/plps/:id', {
        pathParams: { id: idValue },
        timeout: 500,
      }),
    {
      default: () => [] as string[],
      transform: (data) => data?.facets ?? [],
    },
  )
}
